import React, { useState, useEffect } from 'react';
import { Select, SpaceBetween, Button, Box, Modal, Alert } from '@cloudscape-design/components';
import { submissionsApi } from 'api/Submission';
import { useNavigate } from 'react-router-dom';
import { isSubmissionWindowOpen } from '../../common/utility';


const FrameworkModal = ({ visible, setVisible, onSubmit }) => {
  const navigate = useNavigate();
  const [frameworks, setFrameworks] = useState([]);
  const [selectedFramework, setSelectedFramework] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const isWindowOpen = isSubmissionWindowOpen();
  const isFramework2 =  process.env.REACT_APP_FRAMEWORK == 2;

  useEffect(() => {
    const fetchFrameworks = async () => {
      try {
        const data = await submissionsApi.getAllFrameworks();

        // Transform API data to match Select component format
        const formattedFrameworks = data.map((framework, index) => ({
          label: framework.title,
          value: framework.id.toString(),
        }));
        setFrameworks(formattedFrameworks);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching frameworks:', error);
        setLoading(false);
      }
    };

    if (visible) {
      fetchFrameworks();
      setError(null);
    }
  }, [visible]);

  const handleSubmit = async() => {
    if (selectedFramework) {
      setSubmitting(true);
      setError(null);
      
      try {
        onSubmit(selectedFramework);

        const newApplicationData = await submissionsApi.createSubmission({'framework_id': parseInt(selectedFramework.value)});
        setVisible(false);
        navigate(`/application-details/${newApplicationData.id}`);
      } catch (error) {
        console.error('Error creating submission:', error);
        
        if (error.response?.data?.detail?.error_code === 6) {
          setError('Only one submission per year is allowed.');
        } else {
          setError('An error occurred while creating the submission. Please try again.');
        }
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Modal
      onDismiss={() => setVisible(false)}
      visible={visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={() => setVisible(false)}>
              Cancel
            </Button>
            <Button 
              variant="primary"
              onClick={handleSubmit}
              disabled={!selectedFramework || submitting || (!isWindowOpen && isFramework2) }
              loading={submitting}
            >
              Start Submission
            </Button>
          </SpaceBetween>
        </Box>
      }
      header="New Submission"
    >
      <SpaceBetween size="m">
        {error && (
          <Alert
            statusIconAriaLabel="Error"
            type="error"
            header="Error"
            dismissible
            onDismiss={() => setError(null)}
          >
            {error}
          </Alert>
        )}
        
        {(!isWindowOpen && isFramework2) && (
          <Alert type="warning" header="Submission Window Closed">
            New submission are only available from October 1st to November 30th each year.
          </Alert>
        )}
        
        <Box>
          <Select
            placeholder="Choose a framework"
            loadingText="Loading frameworks..."
            statusType={loading ? "loading" : "finished"}
            selectedOption={selectedFramework}
            onChange={({ detail }) => setSelectedFramework(detail.selectedOption)}
            options={frameworks}
          />
        </Box>
      </SpaceBetween>
      <br />
      {selectedFramework?.id && (
        <Box variant="p">
          {selectedFramework.title}
        </Box>
      )}
    </Modal>
  );
};

export default FrameworkModal;